import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import CompaniesAx        from 'app/actions/company-admin/companies';
import ToastAx            from 'app/actions/toast';
import Link               from 'app/components/common/link';
import Meta               from 'app/components/common/meta';
import RteViewer          from 'app/components/common/rich-text/viewer';
import SegmentedInput     from 'app/components/common/segmented-selector-input';
import FormCard           from 'app/components/company-admin/forms/form-card';
import ModalEmail         from 'app/components/company-admin/grant-system/modal-email-form';
import ModalNewWorkflow   from 'app/components/company-admin/grant-system/modal-new-workflow';
import WorkflowCard       from 'app/components/company-admin/grant-system/workflow-card';
import CadminLayout       from 'app/components/company-admin/layout/';
import PageLoading        from 'app/components/layout/page-loading';
import FormsDuck          from 'app/ducks/company-admin/forms';
import GrantSysDuck       from 'app/ducks/company-admin/grant-system';
import paths              from 'app/paths';
import CadminSlx          from 'app/selectors/company-admin/';
import RoutingSlx         from 'app/selectors/routing';

const publicPageOpts = [
  {label: 'Enabled', value: 'true'},
  {label: 'Disabled', value: 'false'},
];

class CadminPageGrantSysSettings extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      grantsPublicProgramsPageEnabled: null,
      publicPageEnabledChanging: false,
      showEmailModalNew: false,
      showEmailModalEdit: null,
      showNewWorkflowModal: false,
    };

    this.onChangePublicPageEnabled = this.onChangePublicPageEnabled.bind(this);
    this.onClickSavePublicPageEnabled = this.onClickSavePublicPageEnabled.bind(this);
    this.onClickEditEmail = this.onClickEditEmail.bind(this);
    this.onClickNewEmail = this.onClickNewEmail.bind(this);
    this.onCloseEmailModal = this.onCloseEmailModal.bind(this);
    this.onClickNewWorkflow = this.onClickNewWorkflow.bind(this);
    this.onCloseNewWorkflow = this.onCloseNewWorkflow.bind(this);
  }

  onChangePublicPageEnabled(opt) {
    const value = opt.value === 'true';
    this.setState({grantsPublicProgramsPageEnabled: value});
  }
  async onClickSavePublicPageEnabled() {
    const {company} = this.props;
    const {grantsPublicProgramsPageEnabled} = this.state;
    this.setState({publicPageEnabledChanging: true});
    await this.props.updateCompany(company.id, {grantsPublicProgramsPageEnabled});
    this.props.toastSuccess('Setting updated.');
    this.setState({publicPageEnabledChanging: false});
  }

  onClickNewWorkflow() {
    this.setState({showNewWorkflowModal: true});
  }
  onCloseNewWorkflow() {
    this.setState({showNewWorkflowModal: false});
  }

  activeClass(tab) {
    return tab === this.props.tab ? 'active' : '';
  }

  renderWorkflows() {
    const {company, workflows} = this.props;
    if (!workflows) return <p>loading...</p>;
    if (!workflows.length) return <p>No workflow templates yet.</p>;

    return (
      <div className="ca-gstg-flows">
        {workflows.map((workflow) => {
          return (
            <WorkflowCard key={workflow.id} workflow={workflow} company={company} />
          );
        })}
      </div>
    );
  }

  renderForms() {
    const {company, forms, programs: allPrograms} = this.props;
    if (!forms) return 'loading...';

    return (
      <div className="ca-gstg-forms">
        {forms.map((form) => {
          return <FormCard key={form.id} className="ca-gstg-forms-form" form={form} company={company} />;
        })}
      </div>
    );
  }

  renderTabWorkflows() {
    const {company, workflows} = this.props;
    if (this.props.tab !== 'workflows') return null;
    return (
      <div className="ca-gstg-tab-content">
        <div className="ca-gstg-tab-content-head">
          <p className="ca-gstg-tab-content-head-exp">Use a workflow template as a starting point when setting up a new program. Once added to a program, it can be configured independently.</p>
          {/* <Link href={paths.cadminGrantWorkflowsNew(company.slug)} className="btn secondary small blue">New Workflow Template</Link> */}
          <button className="btn secondary small blue" onClick={this.onClickNewWorkflow}>New Workflow Template</button>
        </div>
        {this.renderWorkflows()}
      </div>
    );
  }

  onClickEditEmail(email) {
    this.setState({showEmailModalEdit: email});
  }
  onClickNewEmail() {
    this.setState({showEmailModalNew: true});
  }
  onCloseEmailModal() {
    this.setState({showEmailModalEdit: null, showEmailModalNew: false});
  }
  renderTabEmails() {
    const {company} = this.props;
    if (this.props.tab !== 'emails') return null;
    return (
      <div className="ca-gstg-tab-content">
        <div className="ca-gstg-tab-content-head">
          <p className="ca-gstg-tab-content-head-exp"></p>
          <button className="btn secondary small blue" onClick={this.onClickNewEmail}>New Email Template</button>
        </div>
        {this.renderEmails()}
      </div>
    );
  }
  renderEmails() {
    const {emails} = this.props
    if (!emails) return 'loading...';

    return (
      <div className="ca-gstg-emails">
        {emails.map((email) => {
          const typeLabel = (email.type === 'approved') ? 'Award Letter' : 'Declined';
          return (
            <div key={email.id} className="ca-gemail-card">
              <div key={email.id} className="ca-gemail-card-top">
                <div className={`ca-gemail-card-type-chip type-${email.type}`}>{typeLabel}</div>
                <button className="btn xs secondary blue ca-gemail-card-btn" onClick={this.onClickEditEmail.bind(this, email)}>Edit</button>
              </div>
              <label className={`ca-gemail-card-label`}>Subject</label>
              <div className={`ca-gemail-card-subject`}>{email.subject}</div>
              <label className={`ca-gemail-card-label`}>Body</label>
              <div className={`ca-gemail-card-scroller`}>
                <RteViewer md={email.body} className="ca-gemail-card-body" />
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  renderTabForms() {
    const {company, forms} = this.props;
    if (this.props.tab !== 'forms') return null;
    return (
      <div className="ca-gstg-tab-content">
        <div className="ca-gstg-tab-content-head">
          <p className="ca-gstg-tab-content-head-exp">Shared forms can be included in multiple programs' application flows. Use shared forms to change the data collected for many programs in one place.</p>
          <Link href={paths.cadminFormsNew(company.slug)} className="btn secondary small blue">New Shared Form</Link>
        </div>
        {this.renderForms()}
      </div>
    );
  }

  renderTabGeneral() {
    const {company} = this.props;
    if (this.props.tab !== 'general') return null;
    const value = (this.state.grantsPublicProgramsPageEnabled == null) ? company.grantsPublicProgramsPageEnabled : this.state.grantsPublicProgramsPageEnabled;
    const isChanged = value !== company.grantsPublicProgramsPageEnabled;

    return (
      <div className="ca-box">
        <div className="ca-box-header">
          <h1 className="ca-box-header-title">Public Programs Page</h1>
          {company.grantsPublicProgramsPageEnabled && (
            <Link href={paths.grantPrograms(company.slug)} className="btn small secondary blue">View Public Page</Link>
          )}
        </div>
        <div className="ca-box-subheader">The public programs page shows a list of your active grant programs to allow applicants to choose the correct one.</div>
        <div className="ca-box-body">
          <div className="_flex _justify-start _align-center _gap-12">
            <SegmentedInput options={publicPageOpts} onChange={this.onChangePublicPageEnabled} value={`${value}`} />
            {isChanged && (
              <button className="btn blue" onClick={this.onClickSavePublicPageEnabled} disabled={this.state.publicPageEnabledChanging}>{this.state.publicPageEnabledChanging ? 'Saving...' : 'Save'}</button>
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {company, workflows, forms} = this.props;
    const {showEmailModalNew, showEmailModalEdit, showNewWorkflowModal} = this.state;
    if (!company) return <PageLoading />;
    const title = 'Grant Library & Settings';

    return (
      <CadminLayout company={company} activeItem="grant-settings" className="ca-gstg">
        <Meta title={`${title} | Millie`} />

        <div className="ca-main-head">
          <h1 className="ca-main-head-h1">{title}</h1>
        </div>

        <div className="ca-main-tabs">
          <Link href={paths.cadminGrantSysSettings(company.slug, 'forms')} className={`ca-main-tabs-tab ${this.activeClass('forms')}`}>Shared Forms</Link>
          <Link href={paths.cadminGrantSysSettings(company.slug, 'workflows')} className={`ca-main-tabs-tab ${this.activeClass('workflows')}`}>Workflow Templates</Link>
          <Link href={paths.cadminGrantSysSettings(company.slug, 'emails')} className={`ca-main-tabs-tab ${this.activeClass('emails')}`}>Email Templates</Link>
          <Link href={paths.cadminGrantSysSettings(company.slug, 'general')} className={`ca-main-tabs-tab ${this.activeClass('general')}`}>Settings</Link>
        </div>

        {this.renderTabForms()}
        {this.renderTabWorkflows()}
        {this.renderTabEmails()}
        {this.renderTabGeneral()}

        {!!showEmailModalNew && (
          <ModalEmail company={company} onClose={this.onCloseEmailModal} />
        )}
        {!!showEmailModalEdit && (
          <ModalEmail company={company} email={showEmailModalEdit} onClose={this.onCloseEmailModal} />
        )}
        {showNewWorkflowModal && (
          <ModalNewWorkflow onClose={this.onCloseNewWorkflow} />
        )}

      </CadminLayout>
    );
  }

}

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  workflows: GrantSysDuck.Slx.templateWorkflows(state),
  programs: GrantSysDuck.Slx.allPrograms(state),
  forms: FormsDuck.Slx.sharedForms(state),
  tab: RoutingSlx.params(state).tab,
  emails: GrantSysDuck.Slx.allEmails(state),
});
const dispatchToProps = (dispatch) => ({
  updateCompany: (companyId, attrs) => dispatch(CompaniesAx.update(companyId, attrs)),
  toastSuccess: (msg) => dispatch(ToastAx.success(msg)),
});

export default connect(stateToProps, dispatchToProps)(CadminPageGrantSysSettings);
